<template>
    <b-modal
        :id="id"
        size="xl"
        centered
        hide-footer
        @show="$emit('show')"
        @hide="$emit('hide')"
    >
        <template v-slot:modal-header="{ close }">
            <div class="title-wrapper">
                <h3 class="title">{{ title }}</h3>
            </div>
            <i
                class="modal-close i-cross"
                @click="close()"></i>
        </template>
        <slot></slot>
    </b-modal>
</template>

<script>
export default {
    name: 'Modal',
    props: {
        id: {
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'xl'
        }
    }
};
</script>

<style lang="scss" scoped></style>
